import api from '@services/interceptor';
import { useWorkspaceStore } from '@stores/WorkspaceData';
class TimeService {
  constructor(){
    this.wp = undefined
  }
  async Get(allowCreate = true){
    if(!this.wp)this.wp = await useWorkspaceStore()
    try {
      const response = await api.get(`/api/horizon/${this.wp.wpid}`);
      if (!response.data && allowCreate){
        // Горизонта ещё нет — создаём по умолчанию, повторно не пытаемся
        await this.Create()
        return await this.Get(false)
      }
      return response.data;
    } catch (error) {
      console.log(error)
    }
    return null
  }
  async Put(data){
    try {
      const response = await api.put(`/api/horizon/${this.wp.wpid}`, data);
      return response.data;
    } catch (error) {
      console.log(error)
    }
  }
  async Create(){
    try {
      const data = {
        "horizonStart": 0,
        "horizonEnd": 0,
        "simulationStep": "STEP_1_20"
      }
      const response = await api.put(`/api/horizon/${this.wp.wpid}`, data);
      return response.data;
    } catch (error) {
      console.log(error)
    }
  }
}

export const timeService = new TimeService();